import React from 'react';
import { Link } from './navigation';
export const BackButton = ({ children, href }) => {
    return (<Link className="page-back-button" to={href}>
      <i className="page-back-button__icon icon icon-arrow"></i>
      {children}
    </Link>);
};
